import type { AttributeReviewFieldDecisionInput } from "@/graphql/generated";

import { asReviewRow, type RowInput } from "./reviewRow.types";

export type PathAction = "showToSeller" | "unlink" | "copy";

export function isLinked(input: RowInput): boolean {
  const row = asReviewRow(input);
  return Boolean(row.link);
}

export function pathDecision(
  action: PathAction,
  input: RowInput,
  copyOf?: string,
): AttributeReviewFieldDecisionInput {
  const row = asReviewRow(input);
  if (action === "copy")
    return { sourceFieldId: String(row.id), decision: "CLEAR", copyOf };
  const kind = action === "showToSeller" ? row.showKind : row.kind;
  const path = row.ownPath;
  return {
    sourceFieldId: String(row.id),
    decision: "APPROVE",
    ...(kind ? { kind } : {}),
    ...(path ? { path } : {}),
  };
}
